<template>
  <div class="consult-fast-statistics big">
    <div class="page_title">极速问诊统计</div>
    <div class="container">
      <div class="search-box">
        <div class="item">
          <span>医生姓名</span>
          <el-input
            v-model.trim="searchForm.doctor_name"
            size="small"
            placeholder="请输入"
            clearable
            @keyup.enter.native="handleSearch"
          />
        </div>
        <div class="item">
          <span>问诊时间</span>
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            value-format="yyyy-MM-dd"
            unlink-panels
          />
        </div>
        <div class="item action-item">
          <el-button type="primary" size="small" @click="handleSearch"
            >查询</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('2067') : false
            "
            @click="exportData"
            >导出</el-button
          >
        </div>
      </div>

      <div class="summary">
        <span>问诊订单总数：{{ countData.all_fast_count || 0 }}</span>
        <span>接诊订单总数：{{ countData.all_con_count || 0 }}</span>
      </div>

      <div class="table-wrapper">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @sort-change="handleSortChange"
        >
          <el-table-column label="医生信息" min-width="200" prop="doctor_name">
            <template slot-scope="scope">
              <div>{{ scope.row.doctor_name || "-" }}</div>
              <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
              <div v-if="scope.row.hospital">{{ scope.row.hospital }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="医生科室"
            prop="department_name"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.department_name || "-" }}
            </template>
          </el-table-column>

          <el-table-column label="医生职称" prop="title" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.title || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="可接诊订单数"
            prop="fast_count"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.fast_count || 0 }}
            </template>
          </el-table-column>

          <el-table-column
            label="接诊订单数"
            prop="consult_count"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.consult_count || 0 }}
            </template>
          </el-table-column>

          <el-table-column
            label="接诊率"
            prop="consult_lv"
            min-width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ formatRate(scope.row.consult_lv) }}
            </template>
          </el-table-column>

          <el-table-column label="开方数" prop="pre_count" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.pre_count || 0 }}
            </template>
          </el-table-column>

          <el-table-column label="处方支付数" prop="pay_pre" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.pay_pre || 0 }}
            </template>
          </el-table-column>

          <el-table-column
            label="支付处方总金额"
            prop="pay_pre_price"
            min-width="150"
          >
            <template slot-scope="scope">
              {{ formatAmount(scope.row.pay_pre_price) }}
            </template>
          </el-table-column>

          <el-table-column label="药品金额" prop="drug_price" min-width="120">
            <template slot-scope="scope">
              {{ formatAmount(scope.row.drug_price) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import marketing from "@/api/marketing";
import Pagination from "@/components/Pagination/index";

export default {
  components: {
    Pagination,
  },
  data() {
    const end = dayjs().format("YYYY-MM-DD");
    const start = dayjs().subtract(29, "day").format("YYYY-MM-DD");
    return {
      searchForm: {
        doctor_name: "",
        dateRange: [start, end],
      },
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableData: [],
      totalNum: 0,
      tableLoading: false,
      orderBy: "",
      countData: {
        all_fast_count: 0,
        all_con_count: 0,
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      const dateRange = this.searchForm.dateRange || [];
      const params = {
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber,
        doctor_name: this.searchForm.doctor_name,
        create_time_start: dateRange[0] || "",
        create_time_end: dateRange[1] || "",
        order_by: this.orderBy,
      };
      this.tableLoading = true;
      marketing
        .getUserConsultFastStatistics(params)
        .then((res) => {
          if (res.code === 0) {
            const data = res.data || {};
            this.tableData = data.list || [];
            this.totalNum = data.total || 0;
            this.countData = data.count_data || {
              all_fast_count: 0,
              all_con_count: 0,
            };
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.getList();
    },
    handleSortChange({ prop, order }) {
      if (prop !== "consult_lv") {
        return;
      }
      if (order === "ascending") {
        this.orderBy = 1;
      } else if (order === "descending") {
        this.orderBy = 2;
      } else {
        this.orderBy = "";
      }
      this.pagination.page = 1;
      this.getList();
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === "") {
        return "0.00";
      }
      const num = Number(val);
      return isNaN(num) ? val : num.toFixed(2);
    },
    formatRate(val) {
      if (val === null || val === undefined || val === "") {
        return "-";
      }
      if (typeof val === "number") {
        return `${(val * 100).toFixed(2)}%`;
      }
      return val;
    },
    exportData() {
      const loading = this.$loading();
      const dateRange = this.searchForm.dateRange || [];
      const params = {
        doctor_name: this.searchForm.doctor_name,
        create_time_start: dateRange[0] || "",
        create_time_end: dateRange[1] || "",
        order_by: this.orderBy,
      };
      marketing
        .exportUserConsultFastStatistics(params)
        .then((res) => {
          if (res.code === 0 && res.data && res.data.url) {
            const host = `${document.location.protocol}//${window.location.host}${res.data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.search-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 80px;
      text-align: right;
      margin-right: 10px;
      white-space: nowrap;
    }
  }
  .action-item {
    margin-left: auto;
    span {
      width: auto;
      margin-right: 0;
    }
    .el-button + .el-button {
      margin-left: 10px;
    }
  }
}

.summary {
  text-align: left;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  span {
    margin-right: 30px;
  }
}

.table-wrapper {
  border: 1px solid #c9cbd6;
  padding: 0 10px 10px;
  margin-bottom: 20px;
}
</style>